import { render, staticRenderFns } from "./RiskSelection.vue?vue&type=template&id=69143466&scoped=true&"
import script from "./RiskSelection.vue?vue&type=script&lang=js&"
export * from "./RiskSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69143466",
  null
  
)

export default component.exports